import { store } from "~/store";

export default defineNuxtPlugin({
  name: "vuex",
  setup: (nuxtApp) => {
    nuxtApp.vueApp.use(store);
  },
});
